import queryString from 'query-string';
import Mutator from '@magnus/react-native-mutator';
import EvTruck from '@magnus/react-native-evtruck';
import Session from '@wowmaking/react-native-analytics/core/helpers/session';

export default {
  init() {
    EvTruck.init({
      token: process.env.REACT_APP_MAGNUS_TOKEN,
    });

    return Session.init(this).then(() => {
      const path = window.location.pathname;
      const pathParameter = path.slice(1) || 'main';
      const p = queryString.parse(window.location.search);

      this.setUserProperty('testmode', p.testmode);
      this.setUserProperty('mode', p.mode);

      Mutator.setAttribution({
        source: p.utm_source,
        campaign_id: p.campaign_id,
      });

      if (p.utm_source) {
        this.setUserProperty('utm_source', p.utm_source);
      }

      if (p.campaign_id) {
        this.setUserProperty('campaign_id', p.campaign_id);
      }

      if (pathParameter) {
        this.setUserProperty('partition', pathParameter);
      }
    });
  },

  setUserProperty(name, value) {
    EvTruck.setUserProperty(name, value);
  },

  trackEvent(category, action, params) {
    const event = `${category}_${action}`;
    EvTruck.trackEvent(event, params);
    window.dataLayer?.push({
      event,
      ...params,
    }); // GTM
  },
};
